import React, { useState, useEffect } from "react";
import { FormGroup, CustomInput } from "reactstrap";
import { connect } from "react-redux";
import { updateCreateParams } from "../../../actions/create";

export const CheckboxModelSelected = (props) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (props.data.hash_dirty === props.create.WT_model) {
      setChecked(true);
    } else {
      setChecked(false); // need this for rerender
    }
  }, [props.create.WT_model]);

  return (
    <React.Fragment>
      <FormGroup>
        <CustomInput
          type="checkbox"
          id={props.data.hash_dirty}
          checked={checked}
          onChange={(e) => {
            if (e.target.checked) {
              props.updateCreateParams("WT_model", props.data.hash_dirty);
            }
          }}
        />
      </FormGroup>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  create: state.create,
});

export default connect(mapStateToProps, { updateCreateParams })(
  CheckboxModelSelected
);
